import React, { Component } from "react";

import HeaderPanel from "./Components/HeaderPanel";
import ModalAboutDialog from "./Components/ModalAboutDialog";
import ModalContextMenu from "./Components/ModalContextMenu";
import HistoryPanel from "./Components/HistoryPanel";



import "../../../UI/CSS/homepage-styles.css";




export default class HomePage
  extends Component {
  constructor(props) {
    super(props);

    this.state =
    {
      showAboutDialog: false,
      showContextMenu: false,
      contextMenuOptions: null
    }
    this.onAboutDialogRequest = this.onAboutDialogRequest.bind(this);
    this.onContextMenuRequest = this.onContextMenuRequest.bind(this);
    this.onAboutDialogCloseRequest = this.onAboutDialogCloseRequest.bind(this);
    this.onContextMenuCloseRequest = this.onContextMenuCloseRequest.bind(this);


  }

  onAboutDialogRequest() {
    this.setState({ showAboutDialog: true });
  }

  onAboutDialogCloseRequest() {
    this.onContextMenuCloseRequest();
    this.setState({ showAboutDialog: false });
  }

  onContextMenuRequest() {
    this.setState({ showContextMenu: true });
  }

  onContextMenuCloseRequest() {
    this.setState({ showContextMenu: false });
  }



  render() {
    if ((!this.props.userSession) || (!this.props.userSession.isValid)) {
      return <span>Loading...</span>
    }

    console.log("Obs@HomePage");

    return (

      <div id="homepage" style={{marginLeft: "4vw"}}>

        <ModalContextMenu
          show={this.state.showContextMenu}
          onContextMenuCloseRequest={this.onContextMenuCloseRequest}
          onLogoutRequest={this.props.onLogoutRequest}
          onAboutDialogRequest={this.onAboutDialogRequest}
          onAddReceiptPageRequest={this.props.onAddReceiptPageRequest}
          onQuarantinePageRequest = {this.props.onQuarantinePageRequest}
          onPrintTagTestRequest = {this.props.onPrintTagTestRequest}
          userSession={this.props.userSession}
        />
        <ModalAboutDialog
          show={this.state.showAboutDialog}
          deviceInfo={this.props.deviceInfo}
          appInfo={this.props.appInfo}
          onlineInfo={this.props.onlineInfo}
          userSession={this.props.userSession}
          onAboutDialogCloseRequest={this.onAboutDialogCloseRequest}
        />
        <HeaderPanel
          editable={true}
          deviceInfo={this.props.deviceInfo}
          appInfo={this.props.appInfo}
          onlineInfo={this.props.onlineInfo}
          userSession={this.props.userSession}
          userSessionKey={this.props.userSessionKey}
          onAboutDialogRequest={this.onAboutDialogRequest}
          onContextMenuRequest={this.onContextMenuRequest}
          onLogoutRequest={this.props.onLogoutRequest}
          onHomePageRequest={this.props.onHomePageRequest}
          onAddReceiptPageRequest={this.props.onAddReceiptPageRequest}
          onToggleAirplaneMode={this.props.onToggleAirplaneMode}
          onUpdateLocationId={this.props.onUpdateLocationId}
          onUpdateSublocationId={this.props.onUpdateSublocationId}
        />

        <HistoryPanel
          userSession={this.props.userSession}
          userSessionKey={this.props.userSessionKey}
          onlineInfo={this.props.onlineInfo}
          currentObservation={this.props.currentObservation}
          onErrorPageRequest={this.props.onErrorPageRequest}
          onUpdateCurrentObservation={this.props.onUpdateCurrentObservation}
          onQuarantinePageRequest = {this.props.onQuarantinePageRequest}
          onPrintTagTestRequest = {this.props.onPrintTagTestRequest}
          onAddReceiptPageRequest={this.props.onAddReceiptPageRequest}
          onRefreshUserSessionKey = {this.props.onRefreshUserSessionKey}
        />

      </div>
    )
  }
  

}
